import React from 'react'
import {KitDescWrapper, KitTitle, KitDescText, KitButton, ArrowRight} from '../style'

export const KitDesc = ({title, desc, button}) =>  {
    const titles = title.map((data) => {
        return(<KitTitle key={data.id} {...data}>{data.text}</KitTitle>)
    })

    return (
        <KitDescWrapper>
            <div>{titles}</div>
            <KitDescText {...desc}>
                {desc.text}
            </KitDescText>
            <KitButton href={button.link} target='_blank' {...button}>{button.text}{button.arrow ? <ArrowRight/> : ''}</KitButton>
        </KitDescWrapper>
    )
}
